/* AudioLearn — one contact experience from every page and contact link. */
(function () {
  'use strict';

  var modal = document.querySelector('[data-contact-modal]');
  if (!modal) return;
  var opener = null;
  var contactPaths = ['/pages/contact', '/contact'];

  function open(trigger) {
    opener = trigger || document.activeElement;
    if (typeof modal.showModal === 'function' && !modal.open) modal.showModal();
    else modal.setAttribute('open', '');
    var firstField = modal.querySelector('select, input, textarea, button');
    if (firstField) window.setTimeout(function () { firstField.focus(); }, 0);
  }

  function close() {
    if (typeof modal.close === 'function' && modal.open) modal.close();
    else modal.removeAttribute('open');
    if (opener && opener.focus) opener.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-contact-modal-open], a[href]');
    if (!trigger) return;
    if (trigger.hasAttribute('data-contact-modal-open')) {
      event.preventDefault();
      open(trigger);
      return;
    }
    if (trigger.tagName !== 'A') return;
    var url;
    try { url = new URL(trigger.href, window.location.href); } catch (error) { return; }
    var sameSite = url.origin === window.location.origin;
    var contactLink = sameSite && (contactPaths.indexOf(url.pathname) !== -1 || url.hash === '#support-contact' || url.hash === '#inquiry');
    if (!contactLink) return;
    event.preventDefault();
    open(trigger);
  });

  modal.querySelectorAll('[data-contact-modal-close]').forEach(function (button) {
    button.addEventListener('click', close);
  });
  modal.addEventListener('click', function (event) {
    if (event.target === modal) close();
  });
  modal.addEventListener('cancel', function (event) {
    event.preventDefault();
    close();
  });
  if (contactPaths.indexOf(window.location.pathname) !== -1) {
    window.setTimeout(function () { open(null); }, 40);
  }
})();
